import "./tag.scss";

const Tags = (props: any) => {
  const { title } = props;
  return <div className="m-tag">{title ?? "JS"}</div>;
};

export default Tags;
